import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import GUI from 'lil-gui'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'

/**
 * Base
 */
// Debug
// const gui = new GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()
// const axesHelper= new THREE.AxesHelper()
// scene.add(axesHelper)

/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()
const matcapTexture = textureLoader.load('/textures/matcaps/8.png')
matcapTexture.colorSpace = THREE.SRGBColorSpace

const fontsLoader = new FontLoader()
fontsLoader.load('/fonts/helvetiker_regular.typeface.json', (font) => {
  const textGeometry = new TextGeometry('Faisal Husain', {
    font: font,
    size: 0.5,
    depth: 0.2,
    curveSegments:12,
    bevelEnabled:true,
    bevelThickness:0.03,
    bevelSize:0.02,
    bevelOffset:0,
    bevelSegments:5

  })
//   textGeometry.computeBoundingBox()
//   textGeometry.translate(
//     - textGeometry.boundingBox.max.x * 0.5,
//     - textGeometry.boundingBox.max.y * 0.5,
//     - textGeometry.boundingBox.max.z * 0.5
// )
textGeometry.center()
const donutGeometry = new THREE.TorusGeometry(0.3, 0.2, 20, 45)
const donutMaterial = new THREE.MeshMatcapMaterial({ matcap: matcapTexture })

const cubeGeometry = new THREE.BoxGeometry(0.5, 0.5, 0.5)
const cubeMaterial = new THREE.MeshMatcapMaterial({ matcap: matcapTexture })

const sphereGeometry = new THREE.SphereGeometry(0.3, 32, 32)
const sphereMaterial = new THREE.MeshMatcapMaterial({ matcap: matcapTexture })
for(let i = 0; i < 100; i++) {
    // Add donuts
    const donut = new THREE.Mesh(donutGeometry, donutMaterial)
    donut.position.x = (Math.random() - 0.5) * 10
    donut.position.y = (Math.random() - 0.5) * 10
    donut.position.z = (Math.random() - 0.5) * 10
    donut.rotation.x = Math.random() * Math.PI
    donut.rotation.y = Math.random() * Math.PI
    const donutScale = Math.random()
    donut.scale.set(donutScale, donutScale, donutScale)
    scene.add(donut)

    // Add cubes
    const cube = new THREE.Mesh(cubeGeometry, cubeMaterial)
    cube.position.x = (Math.random() - 0.5) * 10
    cube.position.y = (Math.random() - 0.5) * 10
    cube.position.z = (Math.random() - 0.5) * 10
    cube.rotation.x = Math.random() * Math.PI
    cube.rotation.y = Math.random() * Math.PI
    const cubeScale = Math.random()
    cube.scale.set(cubeScale, cubeScale, cubeScale)
    scene.add(cube)

    // Add spheres
    const sphere = new THREE.Mesh(sphereGeometry, sphereMaterial)
    sphere.position.x = (Math.random() - 0.5) * 10
    sphere.position.y = (Math.random() - 0.5) * 10
    sphere.position.z = (Math.random() - 0.5) * 10
    sphere.rotation.x = Math.random() * Math.PI
    sphere.rotation.y = Math.random() * Math.PI
    const sphereScale = Math.random()
    sphere.scale.set(sphereScale, sphereScale, sphereScale)
    scene.add(sphere)
}
    
const textMaterial = new THREE.MeshMatcapMaterial({ matcap: matcapTexture })
  const text= new THREE.Mesh(textGeometry,textMaterial)
  
  scene.add(text)
})
/**
 * Object
 */
// const cube = new THREE.Mesh(
//   new THREE.BoxGeometry(1, 1, 1),
//   new THREE.MeshBasicMaterial(),
// )

// scene.add(cube)

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
}

window.addEventListener('resize', () => {
  // Update sizes
  sizes.width = window.innerWidth
  sizes.height = window.innerHeight

  // Update camera
  camera.aspect = sizes.width / sizes.height
  camera.updateProjectionMatrix()

  // Update renderer
  renderer.setSize(sizes.width, sizes.height)
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
  75,
  sizes.width / sizes.height,
  0.1,
  100,
)
camera.position.x = 1
camera.position.y = 1
camera.position.z = 2
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () => {
  const elapsedTime = clock.getElapsedTime()

  // Update controls
  controls.update()

  // Render
  renderer.render(scene, camera)

  // Call tick again on the next frame
  window.requestAnimationFrame(tick)
}

tick()
